import React, { useState, useEffect } from "react"
import { FilterItem, CheckBox, FilterCount, Label } from "./style"

const Filter = ({ filters, setFilters, label, site, count }) => {
  const [selected, setSelected] = useState(false)
  const handleSelect = () => {
    setSelected(!selected)

    const updatedFilters = filters.filter(function(value) {
      return value !== site
    })

    if (!selected) {
      setFilters([...updatedFilters, site])
      console.log("selected")
    } else {
      setFilters([...updatedFilters])
    }
  }

  useEffect(() => {
    if (typeof window !== `undefined`) {
      const urlParams = new URLSearchParams(window.location.search)
      const filtersParam = urlParams.getAll("f")

      if (filtersParam.includes(site)) {
        handleSelect()
      }
    }
  }, [])
  return (
    <FilterItem site={site} selected={selected}>
      <input onChange={() => handleSelect()} type="checkbox" />
      <CheckBox site={site} selected={selected} />

      <Label>
        <h4>{label}</h4>
      </Label>
      <FilterCount site={site}>
        <span>{count || 0}</span>
      </FilterCount>
    </FilterItem>
  )
}

export default Filter
